export type SentimentBucket =
  | "Extreme Fear"
  | "Fear"
  | "Neutral"
  | "Greed"
  | "Extreme Greed";

export const VALID_BUCKETS: readonly SentimentBucket[] = [
  "Extreme Fear",
  "Fear",
  "Neutral",
  "Greed",
  "Extreme Greed",
] as const;

export const BUCKET_COLORS: Record<SentimentBucket, string> = {
  "Extreme Fear": "#E74C3C",
  "Fear": "#E67E22",
  "Neutral": "#F1C40F",
  "Greed": "#2ECC71",
  "Extreme Greed": "#27AE60",
};

/** Shared watch-label → i18n key map (used by PulseStrip + InfoDrawer) */
export const WATCH_KEYS = {
  fear_deepening: "watchFearDeepening",
  fear_stabilizing: "watchFearStabilizing",
  neutral_compression: "watchNeutralCompression",
  greed_accelerating: "watchGreedAccelerating",
  greed_overheating: "watchGreedOverheating",
  possible_reversal: "watchPossibleReversal",
  trend_persistence: "watchTrendPersistence",
  recovery_building: "watchRecoveryBuilding",
} as const;

/** Shared market-pressure label → i18n key map */
export const PRESSURE_KEYS: Record<string, string> = {
  "broad sell-off": "pressureBroadSellOff",
  "market under pressure": "pressureUnderPressure",
  "broad rally": "pressureBroadRally",
  "risk appetite improving": "pressureRiskAppetite",
  "market flat": "pressureFlat",
  "mixed signals": "pressureMixed",
};
